import { CommissionsTableContainer } from "components/Tables/CommissionsTable/CommissionsTableContainer.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getAdvertiserHeaderItems } from "utils/tenantHeaderItems.ts";


export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/")({
    component: AdvertiserCommissionsPage,
    staticData: {
        permissions: [PermissionEnum.AdvertiserCommissionView],
        showInSideMenu: false,
        label: "pages.advertiser.commission.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.advertiser.commission.title"),
        };
    },
});

function AdvertiserCommissionsPage(): JSX.Element {
    return (
        <TenantPage headerNavigationItems={getAdvertiserHeaderItems}>
            <CommissionsTableContainer
                commissionGroupId={null}
                editPermission={PermissionEnum.AffiliateCommissionCurrentTierEdit}
                showProvisionGroups={true}
                commissionType={"Tenant"}
            />
        </TenantPage>
    );
}
